/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import TableTab from "UpduoLibrary/TableTab";
import { DashboardTableTabType } from "../types";

interface TableTabBarProps {
  isUser: boolean;
  shownTableType: DashboardTableTabType | undefined;
  onTabChoice: (choice: DashboardTableTabType) => void;
}

export default function TableTabBar({
  isUser = false,
  shownTableType,
  onTabChoice,
}: TableTabBarProps) {
  return (
    <View style={{ flexDirection: "row" }}>
      {/* <TableTab
        isFirst={true}
        isActive={shownTableType === "curriculumStat"}
        label={"Content Stats"}
        onPress={() => {
          onTabChoice("curriculumStat");
        }}
      /> */}
      {/* <TableTab
        isFirst={true}
        isActive={shownTableType === "skillProgress"}
        label={"Lesson Progress"}
        onPress={() => {
          onTabChoice("skillProgress");
        }}
      /> */}
      <TableTab
        isActive={shownTableType === "activity"}
        label={"Activity"}
        onPress={() => {
          onTabChoice("activity");
        }}
      />
      <TableTab
        isActive={
          shownTableType === "breakdown" ||
          (isUser && shownTableType === "sessionProgress")
        }
        label={"Breakdown"}
        onPress={() => {
          onTabChoice("breakdown");
        }}
      />
      {isUser ? null : (
        <TableTab
          isActive={shownTableType === "sessionProgress"}
          label={"Session Progress"}
          onPress={() => {
            onTabChoice("sessionProgress");
          }}
        />
      )}
    </View>
  );
}
